import { Typography, Box } from "@mui/material";
import CustomBox from "../Common/CustomBox";
import FAQ from "../Common/FAQ";
import useCustomLogic from "../../../../Hooks/UseCustomLogic";
import PieChart from "../Common/PieChart";
import { useEffect, useState } from "react";
import { LoaderComponent } from "../../../../components/Loader/LoaderComponent";

const faqsStatic = [
  { content: "ATMs", status: "Yes" },
  { content: "Bank Branch", status: "Yes" },
  { content: "Canteen", status: "Yes" },
  { content: "First Aid Care", status: "Yes" },
  { content: "Photocopier", status: "Yes" },
  { content: "Police Booth", status: "Yes" },
  { content: "Post Office", status: "Yes" },
  { content: "Public Notaries", status: "Yes" },
  { content: "Oath Commissioners", status: "Yes" },
  { content: "Stamp Vendors", status: "Yes" },
];

export const Amenities = ({
  selectedDistrict,
  dataState,
  dataDistrict,
  stateId,
  districtId,
  statesList,
}) => {
  const { theme, loader } = useCustomLogic();

  let isDistrict = selectedDistrict == "Select District";
  // Inside your functional component
  const [showDistrictData, setShowDistrictData] = useState([]);
  const [showStateData, setShowStateData] = useState([]);
  const [faqs, setFaqs] = useState(faqsStatic)
 

  useEffect(() => {
    if (dataDistrict && Object.keys(dataDistrict).length > 0) {
       
      let arr = [
        dataDistrict?.atm ?? "",
        dataDistrict?.bank_branch ?? "",
        dataDistrict?.canteen ?? "",
        dataDistrict?.first_aid_care ?? "",
        dataDistrict?.photocopier ?? "",
        dataDistrict?.police_booth ?? "",
        dataDistrict?.post_office ?? "",
        dataDistrict?.public_notary ?? "",
        dataDistrict?.oath_commissioner ?? "",
        dataDistrict?.stamp_vendor ?? "",
      ]

      setFaqs(faqs.map( (item ,index ) => ({...item , status : arr[index]}) ))
      // const districtValues = Object.values(dataDistrict);
      // setShowDistrictData(districtValues);
    }

    // chart data when state is selected
    if (dataState) {
      const data = [
        dataState?.photocopier ?? 0,
        dataState?.typist ?? 0,
        dataState?.stamp_vendor ?? 0,
        dataState?.canteen ?? 0,
        dataState?.public_notary ?? 0,
        dataState?.atm ?? 0,
        dataState?.bank_branch ?? 0,
        dataState?.oath_commissioner ?? 0,
        dataState?.post_office ?? 0,
        dataState?.police_booth ?? 0,
        dataState?.first_aid_care ?? 0,
        dataState?.full_service ?? 0
      ];
      setShowStateData(data);
    }
  }, [dataDistrict, dataState]);

  // useEffect(()=>{
  //   let arr = [];
  //   console.log("use", dataDistrict)
  //     for (const key in dataDistrict) {
  //       arr.push(dataDistrict[key]);
  //     }
  //     setShowDistrictData(arr);
  // },[])

  // const [seriesData, setSeriesData] = useState([]);

  // const stateListData = (stateId, districtId) => {
  //   let path = `/building_better_courts/single_amenities?state_id=${stateId}&district_id=${districtId}`;
  //   dispatch({
  //     type: "GET_BUILDING_BETTER_DATA",
  //     path: path,
  //     successCallBack: successCallBackList,
  //   });
  // };

  // const chartData = (stateId, statesList) => {
  //   let obj = statesList?.find((val) => {
  //     return val.id === stateId;
  //   });
  //   // console.log(obj);

  //   setSeriesData(Object?.values(obj));
  // };

  // const successCallBackList = (res) => {
  //   console.log(res?.data.data, "................34");
  //   let arr = [];
  //   for (const key in res?.data?.data?.court_infra) {
  //     arr.push(res.data.data.court_infra[key]);
  //   }
  //   setShowDistrictData(arr);
  // };

  // useEffect(() => {
  //   console.log("inside useeffect of amenities........");
  //   if (selectedDistrict !== "All Districts")
  //     stateListData(stateId, districtId);
  // }, [selectedDistrict]);

  // useEffect(() => {
  //   chartData(stateId, statesList);
  // }, [stateId]);

  return (
    <>
      {loader ? (
        <LoaderComponent height="50vh" />
      ) : (
        <Box>
          {isDistrict ? (
            <>
              <Box>
                <Typography variant="regular3" color="secondary.main">
                  What services are available in the court complex?
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    mt: "10px",
                    textAlign: "left",
                    letterSpacing: "0.2px",
                    wordSpacing: "1px",
                  }}
                >
                  A full service court is one where all the amenities are
                  present.
                </Typography>
                <Box
                  sx={{
                    marginTop: "50px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  {showStateData?.length > 1 ? (
                    <PieChart seriesData={showStateData} />
                  ) : null}
                </Box>
              </Box>
            </>
          ) : (
            <>
              <CustomBox
                content="Is this a full-service court?"
                style={{
                  fontSize: "24px",
                  color: theme.palette.common.black,
                  backgroundColor: "#e6ebf4",
                }}
              />
              {faqs &&
                faqs?.map((elem, index) => {
                  return (
                    <FAQ
                      content={elem?.content}
                      status={elem.status}
                      isLastItem={index === faqs.length - 1}
                    />
                  );
                })}
            </>
          )}
        </Box>
      )}
    </>
  );
};
